import "./App.css";
import { useState } from "react";
import {
  Row,
  Col,
  Container,
  Form,
  Collapse,
  InputGroup,
} from "react-bootstrap";
import "bootstrap/dist/css/bootstrap.css";
import * as C from "./constants";

const emptyHeader = (
  <center>
    <div className="doc5">
      There are currently no physicians in your area.
      <br />
      Talk to your local physician about the potential for this in-office
      service.
      <br />
    </div>
  </center>
);

const GetDoctorsList = (data) => {
  if (data === [] || data === null || data.error) {
    return null;
  }
  // var nwdata = [];
  // var nmdata = [];
  // data.forEach((i) => {
  //   if (i.nextwave) {
  //     nwdata.push(i);
  //   } else {
  //     nmdata.push(i);
  //   }
  // });
  // var dat = nmdata;
  // if (nwdata.length > 0) {
  //   dat = nwdata;
  // }
  var dat = [];
  if (data.length > 10) {
    for (var i = 0; i < 10; i++) {
      dat.push(data[i]);
    }
  } else {
    dat = data;
  }
  return dat.map((one) => {
    const phone2call = "tel:" + one.phone;
    let nextwave = null;
    if (one.nextwave) {
      nextwave = (
        <Row>
          <Col>
            <div className="nextwavedoc">
              <img src="https://findphysicians.s3.us-west-2.amazonaws.com/nw.png" alt="" /> Physician
              offers in-Office EWSL with nextwave
              <br />
              {/* <Button
            variant="success"
            target="_blank"
            href="https://www.nextmed.net/nextwave"
          >
            Learn more
          </Button>
          {" "} */}
            </div>
          </Col>
        </Row>
      );
    }
    return (
      <Row className="doc-row" key={one.ge_id}>
        <Col md={3}></Col>
        <Col md={6}>
          <span className="doc1">
            Dr. {one.first_name} {one.last_name}
          </span>
          <br />
          <span className="doc2">{nextwave}</span>
          {one.phone !== "" && (
            <span className="doc2">
              <a href={phone2call}>{one.phone}</a>
              <br />
            </span>
          )}
          <span className="doc2">{one.address}</span>
          <br />
          <span className="doc2">
            {one.city}, {one.state}
          </span>
          <br />
          <span className="doc2">{one.zip_code}</span>
        </Col>
        <Col md={3}></Col>
      </Row>
    );
  });
};

function FindPhysicians() {
  const [btnDisabled, setBtnDisabled] = useState(false);
  const [zipCode, setZipCode] = useState("");
  const [physListState, setPhysListState] = useState(false);
  const [items, setItems] = useState([]);
  const [header, setHeader] = useState("");
  var Timer;

  return (
    <div>
      <Container
        fluid
        className="tt-physicians-background"
        id="tt-physicians-section"
      >
        <Row>
          <Col>
            <Row>
              <Col>
                <Form.Group className="tt-physicians-form2">
                  {/* {btnDisabled ? (
                        <div class="spinner-grow" role="status">
  <span class="sr-only">Loading...</span>
</div>
            ):(<div></div>)} */}
                  <InputGroup>
                    <Form.Control
                      className="form-input"
                      type="text"
                      placeholder="Enter your Zip Code"
                      value={zipCode}
                      onChange={(event) => {
                        setHeader("");
                        setItems(null);

                        clearTimeout(Timer);
                        let zc = event.target.value;
                        Timer = setTimeout(function () {
                          if (zc.length === 5) {
                            if (zc[0] === "0") {
                              zc = zc.substring(1);
                            }
                            setBtnDisabled(true);

                            // setZipCode(zc);
                            console.log(zc);

                            fetch(C.urlPhysiciansByZip + zc)
                              .then((res) => res.json())
                              .then(
                                (result) => {
                                  setItems(result);
                                  console.log(result);
                                  setBtnDisabled(false);
                                  if (result.length !== 0) {
                                    setPhysListState(true);
                                  } else {
                                    setPhysListState(false);
                                    setHeader(emptyHeader);
                                  }
                                },
                                (error) => {
                                  setBtnDisabled(false);
                                  setPhysListState(false);
                                }
                              )
                              .catch((error) => {
                                setBtnDisabled(false);
                                setPhysListState(false);
                              });
                          }
                        }, 100);
                        setZipCode(zc);
                      }}
                    />
                  </InputGroup>
                </Form.Group>

                {/* <Form.Group className="tt-physicians-form2">
                  <Form.Label className="form-label">Zip code</Form.Label>
                  <br />
                  <Form.Control
                    className="form-input"
                    type="text"
                    value={zipCode}
                    onChange={(event) => {
                      clearTimeout(Timer);
                      let zc = event.target.value;
                      Timer = setTimeout(function () {
                        if (zc.length === 5) {
                          if (zc[0] === "0") {
                            zc = zc.substring(1);
                          }
                          setError(null);
                          setBtnDisabled(true);
                          setItems(null);

                          // setZipCode(zc);
                          console.log(zc);

                          fetch(C.urlPhysiciansByZip + zc)
                            .then((res) => res.json())
                            .then(
                              (result) => {
                                setItems(result);
                                console.log(result);
                                setBtnDisabled(false);
                                if (result.length !== 0) {
                                  setPhysListState(true);
                                } else {
                                  setPhysListState(false);
                                }
                              },
                              (error) => {
                                setError(error.message);
                                setBtnDisabled(false);
                                setPhysListState(false);
                              }
                            )
                            .catch((error) => {
                              setError(error.message);
                              setBtnDisabled(false);
                              setPhysListState(false);
                            });
                        }
                      }, 1000);
                      setZipCode(zc);
                    }}
                    // onKeyPress={(e) => InputHandler(e)}
                  />
                  {btnDisabled ? (
                  <span>
                  <Spinner
                          as="span"
                          animation="grow"
                          size="sm"
                          role="status"
                          aria-hidden="true"
                        />
                        </span>
                    ) : (
                      <span></span>
  )}
                </Form.Group> */}
              </Col>
            </Row>
            <Row className="found-physicians">
              <Col>
                {header}
                <Collapse in={physListState}>
                  <div id="physicians-list">
                    <Row className="found-physicians-head">
                      <Col style={{ textAlign: "right" }}>
                        <div
                          className="close-button"
                          onClick={() => {
                            setPhysListState(false);
                          }}
                        ></div>
                      </Col>
                    </Row>
                    <center>
                      {btnDisabled ? (
                        <div class="spinner-grow" role="status">
                          <span class="sr-only"></span>
                        </div>
                      ) : (
                        <span></span>
                      )}
                    </center>
                    {GetDoctorsList(items)}
                  </div>
                </Collapse>
              </Col>
            </Row>
          </Col>
        </Row>
      </Container>
    </div>
  );
}

export default FindPhysicians;
